<div class="page ng-scope">
    <div class="container">
        <div class="page-header row">
            <div class="page-title col-auto">
                <div class="page-title-wrap">
                    <div class="d-flex">
                        <div class="page-name">
                            <span class="page-name-text">Indices: Families - {{currFamilyName}}</span>
                        </div>
                    </div>
                    <div class="page-header-navigation-inline">
                        <a class="text-blue" href="/indices">
                            <span class="page-header-navigation-title">Indices</span>
                        </a>
                        <span>&nbsp;/&nbsp;</span>
                        <a class="text-blue" href="/indices/families">
                            <span class="page-header-navigation-title">Families</span>
                        </a>
                        <span>&nbsp;/&nbsp;</span>
                        <span class="page-header-navigation-title text-bold">{{currFamilyName}}</span>
                    </div>
                </div>
            </div>
            <div class="page-header-actions">
                <div class="row visible-md-flex">
                    <div class="col-i-md-4 d-flex align-items-end form-row">
                        <div class="flex-auto row no-gutters align-items-baseline">
                            <div class="col-auto">
                                <div class="form-label form-label-thin mr-1">Search All Indices</div>
                            </div>
                            <div class="col">
                                <ycn-base-autocomplete
                                        [placeholder]="'Search'"
                                        [searchType]="'index'"
                                        [buttonType]="'icon-search'"
                                        [showMoreResultsUrl]="true"
                                        (submitHandler)="redirectToIndex($event)">
                                </ycn-base-autocomplete>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="page-body">
            <div class="panel panel-data panel-stocks">
                <div class="panel-header">
                    <h3 class="panel-title">Performance by Family</h3>
                </div>
                <div class="panel-content">
                    <div class="mb-2">
                        <ycn-indices-page-gainers-losers [currFamilyName]="currFamilyName"></ycn-indices-page-gainers-losers>
                    </div>
                </div>
            </div>
            <ycn-family-indices-table [indexFamily]="currFamilyName"></ycn-family-indices-table>
        </div>
    </div>
</div>
